import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var RadioGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  label {\n    color: ", ";\n    font-family: ", ";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.15px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  label {\n    color: ", ";\n    font-family: ", ";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.15px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
});
export var OptionsContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: wrap;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: wrap;\n  gap: ", ";\n"])), function (_a) {
    var $vertical = _a.$vertical;
    return ($vertical ? "column" : "row");
}, function (_a) {
    var theme = _a.theme, gap = _a.gap;
    return (gap ? gap : theme.spacing.xs);
});
export var ErrorSpan = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  height: 16px;\n  letter-spacing: 0.4px;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  height: 16px;\n  letter-spacing: 0.4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red.default;
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map